var _defs, _g, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#10ad7d;}.b{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 6,
    cy: 6,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 6,
    cy: 6,
    r: 5.5
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 4.5,
    transform: "translate(6.001 5)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 1,
    transform: "translate(6 3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallinfo);
export default __webpack_public_path__ + "static/media/smallinfo.dad1df6d90b35c2f501f89d1c1137393.svg";
export { ForwardRef as ReactComponent };